var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgCampaignTypeAll = function SvgCampaignTypeAll(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.75 3.43267C13.75 2.77933 13.2207 2.25 12.5673 2.25H3.43267C2.77933 2.25 2.25 2.77933 2.25 3.43267V12.5673C2.25 13.2207 2.77933 13.75 3.43267 13.75H12.5673C13.2207 13.75 13.75 13.2207 13.75 12.5673V3.43267V3.43267Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2601 7.99984H7.75342",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11793 7.88199C5.18302 7.94707 5.18302 8.0526 5.11793 8.11769C5.05285 8.18278 4.94732 8.18278 4.88223 8.11769C4.81714 8.0526 4.81714 7.94707 4.88223 7.88199C4.94732 7.8169 5.05285 7.8169 5.11793 7.88199",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2601 4.99984H7.75342",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11793 4.88394C5.18302 4.94903 5.18302 5.05455 5.11793 5.11964C5.05285 5.18473 4.94732 5.18473 4.88223 5.11964C4.81714 5.05455 4.81714 4.94903 4.88223 4.88394C4.94732 4.81885 5.05285 4.81885 5.11793 4.88394",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3199 10.9998H7.81323",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.17653 10.8849C5.24161 10.95 5.24161 11.0555 5.17653 11.1206C5.11144 11.1857 5.00591 11.1857 4.94082 11.1206C4.87574 11.0555 4.87574 10.95 4.94082 10.8849C5.00591 10.8198 5.11144 10.8198 5.17653 10.8849",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCampaignTypeAll;